import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/download-csr-view.svg'


const _hoisted_1 = { class: "csr-wnload-view container" }
const _hoisted_2 = { class: "breadcrumb-password-view pt-3 row" }
const _hoisted_3 = {
  class: "alert alert-dismissible alert-success mb-4",
  role: "alert"
}
const _hoisted_4 = { class: "alert__icon" }
const _hoisted_5 = {
  class: "btn-close pt-0",
  type: "button",
  "data-bs-dismiss": "alert",
  "aria-label": "Fechar"
}
const _hoisted_6 = { class: "content-password-view" }
const _hoisted_7 = { class: "d-flex flex-row row" }
const _hoisted_8 = { class: "col-12 col-lg-6 text-start" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "buttons-container d-flex justify-content-end mt-3 gap-3" }
const _hoisted_11 = {
  id: "modal-only-desktop-issuer-button",
  "data-bs-target": "#modal-only-desktop",
  "data-bs-toggle": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_Contact = _resolveComponent("Contact")!
  const _component_ModalOnlyUseOnDesktop = _resolveComponent("ModalOnlyUseOnDesktop")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Breadcrumb, { pathList: _ctx.pathlist }, null, 8, ["pathList"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Icon, { name: "shield" })
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "alert__content" }, [
        _createElementVNode("div", { class: "text" }, "Certificado emitido com sucesso!")
      ], -1)),
      _createElementVNode("button", _hoisted_5, [
        _createVNode(_component_Icon, { name: "xmark" })
      ])
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "title text-start" }, [
      _createElementVNode("h2", { class: "fw-600" }, "Instalação de Certificado Digital Financeiro e SSL com CSR")
    ], -1)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-12 col-lg-6 d-none d-lg-block text-center" }, [
          _createElementVNode("img", {
            alt: "emitir-certificado",
            src: _imports_0
          })
        ], -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("strong", null, "Usuário: " + _toDisplayString(_ctx.form.user), 1)
          ]),
          _createVNode(_component_TextArea, {
            class: "mb-2",
            label: "Seu Certificado Digital está pronto para download.",
            rows: "4",
            modelValue: _ctx.form.csr,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.csr) = $event)),
            "is-disabled": "",
            size: "185",
            resizable: false,
            overflowHidden: ""
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "copy-button btn btn-outline-primary",
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCopy && _ctx.handleCopy(...args)))
            }, [
              _cache[4] || (_cache[4] = _createElementVNode("span", null, "Copiar", -1)),
              _createVNode(_component_Icon, {
                class: "ms-2",
                name: "copy"
              })
            ]),
            _createElementVNode("button", {
              class: "download-button btn btn-primary",
              type: "button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDownload && _ctx.handleDownload(...args)))
            }, [
              _cache[5] || (_cache[5] = _createElementVNode("span", null, "Baixar Certificado", -1)),
              _createVNode(_component_Icon, {
                class: "ms-2",
                name: "download"
              })
            ])
          ])
        ])
      ]),
      _createVNode(_component_Contact),
      _createVNode(_component_ModalOnlyUseOnDesktop, null, {
        message: _withCtx(() => _cache[7] || (_cache[7] = [
          _createElementVNode("h3", null, [
            _createTextVNode("A instalação de um Certificado Digital através do emissor, deve ser feita em um "),
            _createElementVNode("strong", null, "computador ou notebook.")
          ], -1)
        ])),
        _: 1
      }),
      _withDirectives(_createElementVNode("button", _hoisted_11, null, 512), [
        [_vShow, false]
      ])
    ])
  ]))
}